// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bc-ajuste[data-v-03254c6b]{background-color:#f7f7f7;padding:5px;padding-left:15px;border-radius:5px;font-size:18px}.bc-active a[data-v-03254c6b]{color:#424242}.bc-a[data-v-03254c6b]{color:#0c76b4}.bc-a[data-v-03254c6b]:hover{color:#d1ab00;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
